import { validateId } from '~/repositories/utils';
import { maintenanceServiceUrl } from '~/utils/env';
import { BaseRestRepository } from './baseRestRepository';
import type { MaintenanceRequestCategoryDto } from '~/swagger/maintenance/Api';

export type Category = {
  id: string;
  name: string;
};

export class CategoryRepository<T extends Category> extends BaseRestRepository {
  private readonly baseUrl = `${maintenanceServiceUrl()}/company-portal/maintenance-requests/categories`;

  public async getCategories(): Promise<T[]> {
    const response = await this.fetchWithAuth(this.baseUrl);
    return this.getJsonResponse(response);
  }

  public async getCategory(categoryId: string): Promise<T> {
    validateId(categoryId);
    const url = `${this.baseUrl}/${categoryId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async createCategory(category: Omit<T, 'id'>): Promise<T> {
    const response = await this.fetchWithAuth(
      this.baseUrl,
      {
        method: 'POST',
        body: JSON.stringify(category),
      },
      false
    );
    return this.getJsonResponse(response);
  }

  public async updateCategory(categoryId: string, category: Partial<Omit<T, 'id'>>): Promise<T> {
    validateId(categoryId);
    const url = `${this.baseUrl}/${categoryId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(category),
    });
    return this.getJsonResponse(response);
  }

  public async deleteCategory(categoryId: string): Promise<void> {
    validateId(categoryId);
    const url = `${this.baseUrl}/${categoryId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}

export const maintenanceRequestCategoryRepository = new CategoryRepository<
  Pick<MaintenanceRequestCategoryDto, 'id' | 'name' | 'description'>
>();
